import { render, staticRenderFns } from "./A14.vue?vue&type=template&id=2dba6cca&"
import script from "./A14.vue?vue&type=script&lang=ts&"
export * from "./A14.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports